import { render, staticRenderFns } from "./viewHire.vue?vue&type=template&id=6be46906&scoped=true&"
import script from "./viewHire.vue?vue&type=script&lang=js&"
export * from "./viewHire.vue?vue&type=script&lang=js&"
import style0 from "./viewHire.vue?vue&type=style&index=0&id=6be46906&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be46906",
  null
  
)

export default component.exports